import config from './config';

export default function(app) {
    app.config(config);
};



// WEBPACK FOOTER //
// ./app/core/index.js